import { render } from "./PolicyColumnManageDrawer.vue?vue&type=template&id=227ac65a&scoped=true"
import script from "./PolicyColumnManageDrawer.vue?vue&type=script&lang=js"
export * from "./PolicyColumnManageDrawer.vue?vue&type=script&lang=js"

import "./PolicyColumnManageDrawer.vue?vue&type=style&index=0&id=227ac65a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227ac65a"]])

export default __exports__